import { useEffect, useState } from "react";
import Contact from "../components/Contact/Contact";
import Hero from "../components/Hero/Hero";
import SectionView from "../components/SectionView/SectionView";
import { getSections } from "../services/sanity";
import type { Section } from "../types";

export default function Home() {
  const [sections, setSections] = useState<Section[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSections() {
      try {
        const data = await getSections();
        setSections(data);
      } catch (error) {
        console.error("Error fetching sections:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchSections();
  }, []);

  return (
    <main
      id="home-scroll-container"
      className="h-screen overflow-y-scroll snap-y snap-mandatory"
      style={
        {
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          height: "100dvh",
          WebkitOverflowScrolling: "touch",
          overscrollBehavior: "contain",
        } as React.CSSProperties
      }
    >
      <style>{`
        main::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      {/* Hero Section */}
      <Hero />

      {/* Three Section Views */}
      {loading ? (
        <section
          id="categories"
          className="min-h-screen flex items-center justify-center"
          style={{ backgroundColor: "#0f1114", height: "100dvh" }}
        >
          <div className="text-white text-2xl">Loading sections...</div>
        </section>
      ) : (
        sections.map((section, index) => (
          <SectionView
            key={section._id}
            sectionId={section.slug.current}
            sectionSlug={section.slug.current}
            index={index}
          />
        ))
      )}

      {/* Contact Section */}
      <Contact />
    </main>
  );
}
